import { relayService } from './relayService';
export const fetchRelayTrade = async (params, config) => {
    return await relayService.post(`${config.VITE_RELAY_API_URL}/quote`, params);
};
